// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputModal_wrapper__3fGYG","content":"InputModal_content__2Wjje"};